// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const ADDSTOPBTN_UPDATE_LABEL = 'ADDSTOPBTN_UPDATE_LABEL';
export const updateAddStopBtnLabel = makeActionCreator(ADDSTOPBTN_UPDATE_LABEL, 'label');
